import { Component, ElementRef, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import videojs from 'video.js';
import { MovieService } from 'src/app/Core/services/movie.service';
import { UtilService } from 'src/app/Core/services/util.service';
import { Location } from '@angular/common';
import BigPlayButton from '../../series/bigplaybutton';
import { Subscription } from 'rxjs';
videojs.registerComponent('BigPlayButton', BigPlayButton);

@Component({
  selector: 'app-movieplayer',
  templateUrl: './movieplayer.component.html',
  styleUrls: ['./movieplayer.component.css']
})
export class MovieplayerComponent implements OnInit , OnDestroy {
  id: string;
  movieinfo: any;
  stream_Url: string;
  OneStream_Url:string;
  extension: any;
  catId:any
  player:any;

  OToken:any;
  //custom player 
  isFavourit:boolean=false;
  videoWrapper: HTMLElement;
  video: HTMLVideoElement;
  videoControls: HTMLElement;
  epgImage: string =''
  videoTitle: string = '';
  videoDuration: string = '00:00';
  totalVideoDuration:string = '00:00';
  fullscreenControl: HTMLElement;
  playControl: HTMLElement;
  stopControl: HTMLElement;
  replayControl: HTMLElement;
  rewindControl: HTMLElement;
  forwardControl: HTMLElement;
  volumeControl: HTMLElement;
  volumeSlider: HTMLInputElement;
  progressBar: HTMLElement;
  captionControl: HTMLElement;

  private touchStartY: number = 0;
private touchStartX: number = 0;
private lastVolume: number = 1;
private lastBrightness: number = 1; // simulate via overlay
private isRightSide: boolean = false;

  isFullScreen:boolean=false;
  hideControlsTimeout: any;
  private controlsTimeout:any;
  private logoutSubscription: Subscription;
  constructor(private router: Router,
    private route: ActivatedRoute, private movieService: MovieService, private utilService: UtilService,private location:Location,private elRef:ElementRef) { 

      this.route.queryParams.subscribe((param: any) => {
      console.log(param);
      
      this.catId = param['categoryId'] || 'all';
      console.log(this.catId);
      
      })
    }

  ngOnInit(): void {
    require('videojs-seek-buttons');

    this.id = this.route.snapshot.params['id'];
    if (this.id) {
      this.getMovieInfo();
    } setTimeout(() => {
      this.playMovie();
    }, 1500);
  //  this.catId =localStorage.getItem('catId')
   this.logoutSubscription = this.utilService.logout$.subscribe(() => {
    // this.exitPictureInPicture();
  });
  // custom player 
  this.videoWrapper = document.querySelector('.video-container') as HTMLElement;
  this.video = document.querySelector('.video-container__video') as HTMLVideoElement;
  this.videoControls = document.querySelector('.video-container__controls') as HTMLElement;
  this.fullscreenControl = document.querySelector('.control--fullscreen') as HTMLElement;
  this.playControl = document.querySelector('.control--play') as HTMLElement;
  // this.stopControl = document.querySelector('.control--stop') as HTMLElement;
  this.replayControl = document.querySelector('.control--replay') as HTMLElement;
  this.rewindControl = document.querySelector('.control--backward') as HTMLElement;
  this.forwardControl = document.querySelector('.control--forward') as HTMLElement;
  this.volumeControl = document.querySelector('.control--volume__button') as HTMLElement;
  this.volumeSlider = document.querySelector('.control--volume__slider') as HTMLInputElement;
  this.progressBar = document.querySelector('.progress') as HTMLElement;
  this.captionControl = document.querySelector('.control--caption') as HTMLElement;
  this.addEventListeners();
  }

  // New Player 
   addEventListeners() {
    this.videoWrapper.addEventListener('touchstart', e => this.handleTouchStart(e), false);
this.videoWrapper.addEventListener('touchmove', e => this.handleTouchMove(e), false);

    this.videoWrapper.addEventListener('mouseover', () => this.playerControlsVisibility(true));
    this.videoWrapper.addEventListener('mouseout', () => this.playerControlsVisibility(false));
    this.videoWrapper.addEventListener('mousemove', () => this.playerControlsVisibility(true));
    this.video.addEventListener('loadedmetadata', () => this.updateVideoInfo());
    this.playControl.addEventListener('click', e => this.togglePlayPause(e));
    // this.stopControl.addEventListener('click', () => this.stopVideo());
    this.replayControl.addEventListener('click', () => this.replayVideo());
    this.rewindControl.addEventListener('click', () => this.rewindVideo());
    this.forwardControl.addEventListener('click', () => this.forwardVideo());
    this.volumeControl.addEventListener('click', e => this.toggleMute(e));
    this.volumeSlider.addEventListener('input', () => this.changeVolume());
    this.video.addEventListener('timeupdate', () => this.updateProgress());
    this.progressBar.addEventListener('click', e => this.seek(e));
    this.fullscreenControl.addEventListener('click', () => this.toggleFullscreen());
    // this.captionControl.addEventListener('click', () => this.toggleCaptions());
    document.addEventListener('webkitfullscreenchange', () => this.onFullscreenChange());
    document.addEventListener('mozfullscreenchange', () => this.onFullscreenChange());
    document.addEventListener('fullscreenchange', () => this.onFullscreenChange());
  }
  handleTouchStart(event: TouchEvent): void {
  if (!event.touches.length) return;
  const touch = event.touches[0];
  this.touchStartY = touch.clientY;
  this.touchStartX = touch.clientX;
  this.isRightSide = (touch.clientX > window.innerWidth / 2); // Right half = volume
  console.log(this.isRightSide,'rightside');
  
}
handleTouchMove(event: TouchEvent): void {
  if (!event.touches.length) return;
  const touch = event.touches[0];
  const deltaY = this.touchStartY - touch.clientY; // Swipe up is positive

  const sensitivity = 0.005; // tweak this

  if (this.isRightSide) {
    // Volume control
    let newVolume = this.video.volume + (deltaY * sensitivity);
    newVolume = Math.max(0, Math.min(1, newVolume));
    this.video.volume = newVolume;
    this.volumeSlider.value = newVolume.toString();
    console.log(this.volumeSlider.value);
    
  } else {
    // Brightness simulation (overlay)
    let newBrightness = this.lastBrightness + (deltaY * sensitivity);
    newBrightness = Math.max(0.2, Math.min(1, newBrightness));
    console.log(newBrightness);
    
    this.setBrightness(newBrightness);
  }
}
setBrightness(value: number) {
  this.lastBrightness = value;
  const overlay = document.querySelector('.brightness-overlay') as HTMLElement;
  overlay.style.opacity = (1 - value).toString(); // inverse brightness
}

   @HostListener('window:keydown', ['$event'])
    handleKeyDown(event: KeyboardEvent): void {
      if (event.key === 'f' || event.key === 'F') {
        this.toggleFullscreen();
      }
    }

  updateVideoInfo() {
    this.videoTitle =  this.movieinfo?.info?.name;
    const duration = this.video.duration;
    this.updateRemainingTime();
    this.video.addEventListener('timeupdate', () => this.updateRemainingTime());
   }

    formatTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
  
    if (hours > 0) {
    return `${this.padTime(hours)}:${this.padTime(minutes)}:${this.padTime(secs)}`;
    } else {
    return `${this.padTime(minutes)}:${this.padTime(secs)}`;
    }
    }

    private updateRemainingTime(): void {
    const remainingTime =  this.video.currentTime;
    this.videoDuration = this.formatTime(remainingTime);
    this.totalVideoDuration = this.formatTime(this.video.duration);

    }

    private padTime(time: number): string {
    return time.toString().padStart(2, '0');
    }

  togglePlayPause(e: Event) {
    const target = e.currentTarget as HTMLElement;
    if (target.classList.contains('paused')) {
      this.video.play();
    } else {
      this.video.pause();
    }
    target.classList.toggle('paused');
  }

  // stopVideo() {
  //   this.video.pause();
  //   this.video.currentTime = 0;
  //   this.playControl.classList.add('paused');
  // }

  replayVideo() {
    this.video.currentTime = 0;
    this.playControl.classList.remove('paused');
    this.video.play();
  }

  rewindVideo() {
    this.video.currentTime -= 10;
  }

  forwardVideo() {
    this.video.currentTime += 10;
  }
  changeVolume(): void {
    const volume = parseFloat(this.volumeSlider.value);
    
    this.video.volume = volume;
    const parent = this.volumeSlider.parentElement as HTMLElement;
    if (volume > 0) {
    parent.classList.remove('muted');
    } else {
    parent.classList.add('muted');
    }
    }

  toggleMute(e: Event) {
    const target = (e.currentTarget as HTMLElement).parentNode as HTMLElement;
    target.classList.toggle('muted');
    if (target.classList.contains('muted')) {
      this.volumeSlider.value = '0';
      this.video.volume = 0;
    } else {
      this.volumeSlider.value = '1';
      this.video.volume = 1;
    }
  }
  toggleCaptions() {
    const track = this.video.textTracks[0];
    console.log(track,'goot');
    
    if (track.mode === 'showing') {
      track.mode = 'hidden';
    } else {
      track.mode = 'showing';
    }
  }
  toggleFullscreen() {
    if (!document.fullscreenElement) {
        // Define fullscreen options
        const fullscreenOptions: FullscreenOptions = { navigationUI: "show" };

        // Enter fullscreen mode with options
        this.videoWrapper.requestFullscreen(fullscreenOptions)
            .catch(err => {
                console.error(`Error attempting to enable fullscreen mode: ${err.message}`);
            });
        console.log(fullscreenOptions);
        // this.utilService.showErrorSuccess('Fullscreen')
        this.setEpgImagePosition('absolute', '-54rem');
    } else {
        // Exit fullscreen mode
        document.exitFullscreen()
            .catch(err => {
                console.error(`Error attempting to exit fullscreen mode: ${err.message}`);
            });

        this.setEpgImagePosition('absolute', '-46rem'); // Reset position when exiting fullscreen
    }
    this.applyFullscreenStyles();

}
applyFullscreenStyles() {
  const toastElement = document.querySelector('.custom-toast') as HTMLElement; // Cast to HTMLElement
  if (toastElement) {
    toastElement.style.zIndex = '10000';  // Ensure high z-index
  }
}


/* Close fullscreen */
closeFullscreen() {
  if ((document as Document).exitFullscreen) {
  (document as Document).exitFullscreen();
  this.isFullScreen = false;
    this.openControlFullscreen();
  } else if ((document as Document).exitFullscreen) {
  /* Safari */
  (document as Document).exitFullscreen();
  this.isFullScreen = false;
  this.openControlFullscreen();
  }
  }

  closeControlFullscreen(){
  //  setTimeout(() => {
  //   this.videoControls.style.display = this.isFullScreen ? 'none' : 'inline'
  //  }, 5000);
  }
  openControlFullscreen(){
    // setTimeout(() => {
    //   this.videoControls.style.display = this.isFullScreen ? 'none' : 'inline'
    //  }, 1000);
  }

onFullscreenChange() {
  const isFullscreen = !!document.fullscreenElement;
  const expandIcon = this.fullscreenControl.querySelector('img.fa-expand') as HTMLElement;
  const compressIcon = this.fullscreenControl.querySelector('i.fa-compress') as HTMLElement;
  
  if (expandIcon && compressIcon) {
    expandIcon.style.display = isFullscreen ? 'none' : 'inline';
    compressIcon.style.display = isFullscreen ? 'inline' : 'none';
  }

  if (isFullscreen) {
    this.hideControlsAfterTimeout();
    this.setEpgImagePosition('absolute', '-55rem');

  } else {
    this.showControls();
    this.setEpgImagePosition('absolute', '-46rem');

  }
}
setEpgImagePosition(position: string, top: string) {
  const epgImage = document.querySelector('.epg-image') as HTMLElement;
  if (epgImage) {
    epgImage.style.position = position;
    epgImage.style.top = top;
  }
}

showControls() {
  this.videoControls.classList.add('visible');
  clearTimeout(this.hideControlsTimeout);
}

hideControls() {
  this.videoControls.classList.remove('visible');
}

hideControlsAfterTimeout() {
  this.showControls();
  this.hideControlsTimeout = setTimeout(() => {
    if (document.fullscreenElement) {
      this.hideControls();
    }
  }, 5000);
}



  updateProgress() {
    const progress = (100 / this.video.duration) * this.video.currentTime;
    document.querySelector('.progress__current').setAttribute('style', `width:${progress}%`);
  }

  seek(e: MouseEvent) {
    const offsetX = e.offsetX;
    const goToTime = (offsetX / this.progressBar.offsetWidth) * this.video.duration;
    this.video.currentTime = goToTime;
  }


  playerControlsVisibility(visible: boolean) {
    if (visible) {
      this.videoControls.classList.add('visible');
      this.startControlsHideTimer()
    } else {
      this.videoControls.classList.remove('visible');
    }
  }
  startControlsHideTimer() {
    this.clearControlsHideTimer(); // Ensure no previous timer is running
    this.controlsTimeout = setTimeout(() => {
      this.videoControls.classList.remove('visible');
    }, 3000); // 3 seconds
  }
  
  clearControlsHideTimer() {
    if (this.controlsTimeout) {
      clearTimeout(this.controlsTimeout);
      this.controlsTimeout = null;
    }
  }

  getMovieInfo() {
    this.movieService.getMovieDeatil(this.id).subscribe((res: any) => {
      this.movieinfo = res;
      if (this.movieinfo.vod) {
        const  url = this.movieinfo.vod.links.mkv || this.movieinfo.vod.links.mp4;
        this.OneStream_Url = url;
      }
      else{
        this.extension = this.movieinfo.movie_data.container_extension;
       this.stream_Url = this.movieService.getStremMovieUrl(this.id, this.extension);

        //this.playMovie();
      }
    }, err => {
      this.utilService.showErrorCall(err);
    });
  }
  playMovie() {
    this.stream_Url = this.movieService.getStremMovieUrl(this.id, this.extension);
    console.log("playmovie",this.stream_Url);
    //this.stream_Url = 'https://www.w3schools.com/html/mov_bbb.mp4';
    setTimeout(() => {
      videojs("movie-player",{autoplay:true,
        preload:"auto",}).src([
        { type: "video/mp4", src: this.stream_Url },
        { muted: true }
      ]);

      this.video.play();
      this.playControl.classList.remove('paused');

      // Create a track object.
      var player = videojs("movie-player");

      var track = new videojs.AudioTrack({
        id: 'my-spanish-audio-track',
        kind: 'translation',
        label: 'Spanish',
        language: 'es'
      });
      console.log(track,'its track..............');
      var audioTrackList = player.audioTracks();
      console.log(audioTrackList,'audio track list---->');
      
      // Listen to the "change" event.
      audioTrackList.addEventListener('change', function() {

        // Log the currently enabled AudioTrack label.
        for (var i = 0; i < audioTrackList.length; i++) {
          var track = audioTrackList[i];
          console.log(track,'movies track -------->');
          
          if (track.enabled) {
            videojs.log(track.label);
            return;
          }
        }
      });

      // Add the track to the player's audio track list.
      player.audioTracks().addTrack(track);

      // var player = videojs("example-videoMovie");
      // this.player = player
      // player.seekButtons({
      //   back: 10,
      //   forward: 10
      // });
      // player.on('play',()=>{
      //   player.removeChild('BigPlayButton')
      // })
      // player.on('pause',()=>{
      //   player.addChild('BigPlayButton')
      // })
      // player.on('ended', function () {
      //   this.location.back()
      //   this.dispose();
      // });
      // player.on('loading',()=>{
      //   player.removeChild('BigPlayButton')
      // })
      // player.on('error', () => {
      //   player.removeChild('BigPlayButton')
      // })
      // var fullscreen = player.controlBar.getChild("FullscreenToggle")
      // var index = player.controlBar.children().indexOf(fullscreen)

      // var myButton = player.controlBar.addChild("button", {}, index);

      // console.log(player.controlBar.getChild("Heart"))
      // var myButtonDom = myButton.el();
      // myButtonDom.innerHTML = "<span class='heart-emoji'>&#10084;&#65039;</span>";
      // myButtonDom.onclick = function(){
      //   alert("Hello");
      // }  

      
      
    }, 200);

  }

  playMovie_() {

    setTimeout(() => {
      videojs("movie-player").src([
        { type: "video/mp4", src: this.OneStream_Url || this.stream_Url },
        { muted: true },
      ]);
  
      
      var player = videojs("movie-player");
      // this.player = player
      // player.seekButtons({
      //   back: 10,
      //   forward: 10
      // });
      // player.on('play',()=>{
      //   player.removeChild('BigPlayButton')
      // })
      // player.on('pause',()=>{
      //   player.addChild('BigPlayButton')
      // })
      // player.on('ended', function () {
      //   this.location.back()
      //   this.dispose();
        
      // });
      // player.on('loading',()=>{
      //   player.removeChild('BigPlayButton')
      // })
      // player.on('error', () => {
      //   player.removeChild('BigPlayButton')
      // })
     
    }, 200);

  }

 
  // addKeyPressEvent() {
    
  //   this.elRef.nativeElement.addEventListener('keypress', (event) => {
  //     if (event.keyCode === 32) {
  //       this.togglePlayPause();  
  //     }
  //   });
  // }
  // togglePlayPause(){
  //   if(this.player.paused()){
  //     this.player.play()
  //   }else{
  //     this.player.paused()
  //   }
  // }
  backToInfo(){
    // this.router.navigate(['/movies/info/' + this.id]);
    // this.router.navigate([`/movies/info/${this.id}?movieBy=movies&categoryId=${this.catId}`])
    console.log(this.id,this.catId);
    this.location.back();
    
    // this.dispose();
    // window.close();
    // this.router.navigate(['/movies'])
  }
  ngOnDestroy(): void {
    var player = videojs('movie-player');
    player.dispose()
    // if (this.logoutSubscription) {
    //   this.logoutSubscription.unsubscribe();
    // }
    if(player.exitPictureInPicture()){
      console.log('log datas',document.exitPictureInPicture());
      
      document.exitPictureInPicture()
    }
  }
  // private exitPictureInPicture() {
  //   if (document.pictureInPictureElement) {
  //     document.exitPictureInPicture().catch((error) => {
  //       console.error('Error exiting PiP:', error);
  //     });
  //   }
  // }

  

}
